import { SyntheticEvent, useEffect, useRef, useState } from "react";
import {
  Machine,
} from "../../../../../explorer/types/SpareParts";
import {
  BoxContainerStyled,
  ButtonsGroup,
  ContentStyled,
  GroupContentStyled,
  LabelStyled,
  StyleArrowIcon,
  StyledBoxMachineSelected,
  StyledBoxSortOrderSelected,
  SubContainerStyled,
  TextConfirmButtonStyled,
  useClasses,
} from "./FilterSearchContent.style";
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
  Box,
  TextField,
} from "@mui/material";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { useParams } from "react-router";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import ClearIcon from "@mui/icons-material/Clear";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React from "react";

import { FilterSearchSortOrderPopup } from "./FilterSearchSortOrderPopup";
import SearchBarSitesMachines from "../../../../components/SearchBarSitesMachines/SearchBarSitesMachines";

type FilterSearchContentProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  
  applyFilter:boolean;
  setApplyFilter:any;

  machineFilterSelected: any;
  setMachineFilterSelected: React.Dispatch<React.SetStateAction<any>>;

  sortOrders: any;

  sortOrderSelected: optionType ;
  setSortOrderSelected: React.Dispatch<React.SetStateAction<any>>;
};

type optionType = {
  id: string;
  label: string;
};

export const FilterSearchContent = (props: FilterSearchContentProps) => {
  const { t } = useTranslation();
  const { codeSearched } = useParams();
  const classes = useClasses();

  const [sortOrder, setSortOrder] = useState<optionType>(props.sortOrders[0]);
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorSearchMachineEl, setAnchorSearchMachineEl ]= React.useState<null | HTMLElement>(null);
  const [openPopupSearchmachine, setOpenPopupSearchmachine] =useState<boolean>(false);
 
  const [currentMachine, setCurrentMachine] = useReduxState<Machine>(reduxStoreConfig.sparePartsCurrentMachine);

  const handleSortOrderPopupOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
  };
  const isSortOrderListOpen = Boolean(anchorEl);

  const isSearchMachineListOpen = Boolean(anchorSearchMachineEl);


  const resetFilter = (init: boolean) => {
    props.setMachineFilterSelected({
      id: "",
      label: t("common.spareparts.all_machines"),
    });
    setSortOrder(props.sortOrders[0]);
  };

  
 

 

  const handleApplyFiltersClick = () => {
    props.setSortOrderSelected(sortOrder);
    props.setMachineFilterSelected(props. machineFilterSelected);
    props.setApplyFilter(true);
  };

  const handleResetFiltersClick = () => {
    resetFilter(true);
  };

  const handleResultClickMachine = (machine: Machine) => {
    setAnchorSearchMachineEl(null);
    setOpenPopupSearchmachine(false);
    const newValue: optionType = {
      id: "" + machine.id,
      label: machine.serialNumber + "-" + machine.description!,
    };
    props.setMachineFilterSelected(newValue);
  };


   const handleSortOrderPopupCancel = () => {
       setAnchorEl(null);
   };
  
   const handleSortOrderPopupClose = (newValue: optionType) => {
      
      setAnchorEl(null);
      if (newValue!=null) {
        setSortOrder(newValue);
     }
   };
 
  const searchMachineBarRef = useRef<any>(null);

    
  const handleOnClickOnSearchMachine = (
      event: any
  ) => {
          setAnchorSearchMachineEl(event.currentTarget);
          setOpenPopupSearchmachine(true);
  };

  return (
      <BoxContainerStyled>
          <SubContainerStyled>
              <GroupContentStyled>
                  <ContentStyled>
                      <SearchBarSitesMachines
                          openState={openPopupSearchmachine}
                          setOpenState={setOpenPopupSearchmachine}
                          anchorElExternal={anchorSearchMachineEl}
                          context={"search"}
                          resultClickMachine={handleResultClickMachine}
                      />
                      <Box
                          style={{
                              display: "flex",
                              cursor: "pointer",
                              flexDirection: "row",
                          }}
                          onClick={(e: any) => {
                              handleOnClickOnSearchMachine(e);
                          }}
                      >
                          <StyledBoxMachineSelected>
                              {props.machineFilterSelected !== undefined && props.machineFilterSelected.label}
                          </StyledBoxMachineSelected>
                          <StyleArrowIcon direction={"down"} />
                      </Box>
                  </ContentStyled>
                  <ContentStyled sx={{marginLeft: '20px',}}>
                      <LabelStyled>
                          {t("common.spareparts.search.orderedType.selectBy")}
                      </LabelStyled>
                      <Box
                          aria-owns={
                              isSortOrderListOpen
                                  ? "mouse-over-popover"
                                  : undefined
                          }
                          aria-haspopup="true"
                          onClick={(e: any) => {
                              handleSortOrderPopupOpen(e);
                          }}
                          style={{
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "row",
                          }}
                      >
                          <StyledBoxSortOrderSelected>
                              {sortOrder !== undefined && sortOrder.label}
                          </StyledBoxSortOrderSelected>
                          <StyleArrowIcon direction={"down"} />
                      </Box>

                      <FilterSearchSortOrderPopup
                          anchorEl={anchorEl}
                          open={isSortOrderListOpen}
                          handlePopupClose={handleSortOrderPopupClose}
                          sortOrders={props.sortOrders}
                          sortOrderSelected={sortOrder}
                          onCancel={handleSortOrderPopupCancel}
                      />
                      {/*
                      <Box
                          style={{
                              display: "flex",
                              flexDirection: "column",
                          }}
                      >
                          <Autocomplete
                              key={"selectFilterSort"}
                              disablePortal
                              popupIcon={<KeyboardArrowDownIcon />}
                              clearIcon={<ClearIcon />}
                              options={props.sortOrders}
                              onChange={handleOptionListSortChange}
                              onInputChange={handleOptionTextSortChange}
                              value={sortOrder || null}
                              renderInput={(params) => (
                                  <TextField {...params} />
                              )}
                          />
                      </Box>
                       */}
                  </ContentStyled>
              </GroupContentStyled>

              <ButtonsGroup>
                  <TextConfirmButtonStyled
                      color="secondary"
                      onClick={handleResetFiltersClick}
                  >
                      {t("common.spareparts.filter.reset_lbl")}
                  </TextConfirmButtonStyled>
                  <TextConfirmButtonStyled
                      variant="contained"
                      onClick={handleApplyFiltersClick}
                      color="primary"
                  >
                      {t("common.spareparts.filter.applyfilters")}
                  </TextConfirmButtonStyled>
              </ButtonsGroup>
          </SubContainerStyled>
      </BoxContainerStyled>
  );
};
